import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import FloatingActionButton from 'material-ui/FloatingActionButton';

import COLORS from '../../../theme/colors';
import './user_avatar.scss';

export default class UserAvatar extends Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleAvatarClick(event) {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestClose() {
    this.setState({
      open: false,
    });
  }

  render() {
    return (
      <div className="user-avatar">
        <FloatingActionButton
          mini
          onClick={event => this.handleAvatarClick(event)}
        >
          <Avatar
            color={COLORS.blue}
            backgroundColor={COLORS.turquoise}
            style={{ width: '30px', height: '30px' }}
          >
            { this.props.user.email[0].toUpperCase() }
          </Avatar>
        </FloatingActionButton>

        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={() => this.handleRequestClose()}
        >
          <Menu>
            <MenuItem primaryText="Sign out" onClick={this.props.logout} />
          </Menu>
        </Popover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app_bar_user_profile/user_avatar/user_avatar.jsx